import { forwardRef } from 'react';

import type { IconProps } from './types';

export const ArrowLeft = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      fillRule="nonzero"
      d="M21.883 9.879H7.223l4.859-4.86a2.134 2.134 0 0 0 0-2.992 2.13 2.13 0 0 0-2.996 0L.613 10.5a2.134 2.134 0 0 0 0 2.992l8.473 8.473c.426.426.96.625 1.5.625.535 0 1.07-.2 1.496-.625a2.134 2.134 0 0 0 0-2.992l-4.86-4.86h14.66A2.132 2.132 0 0 0 24 11.996c0-1.156-.96-2.117-2.117-2.117Zm0 0"
      fill={color}
    />
  </svg>
));

export default ArrowLeft;
